import { AquatecSystemApiEnum } from 'submodules/nerit-aquatec-sdk/common/AquatecSystemApiEnum'
import { HttpMethodEnum } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/enums/HttpMethodEnum'
import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { MatrixSaveRequestDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/requests/MatrixSaveRequestDTO'
import { MatrixSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/requests/MatrixSearchRequestDTO'
import { MatrixLocationsRequestDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/requests/MatrixLocationsRequestDTO'
import { AvailableLocationsRequestDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/requests/AvailableLocationsRequestDTO'
import { MatrixResponseDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/responses/MatrixResponseDTO'

export class MatrixRequests {

	public static CONTROLLER_ROOT = 'matrix'
	public static SEARCH_EP = 'search'
	public static GET_EP = 'get/:code'
	public static SAVE_EP = 'save'
	public static UPDATE_EP = 'update/:code'
	public static DELETE_EP = 'delete/:code'
	public static ADD_LOCATIONS_EP = 'add-locations/:code'
	public static REMOVE_LOCATION_EP = 'remove-location/:code/:locationCode'
	public static LOCATIONS_EP = 'locations/:code'
	public static AVAILABLE_LOCATIONS_EP = 'available-locations'

	static search = (dto: MatrixSearchRequestDTO): RequestConfigTP<MatrixResponseDTO> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${MatrixRequests.CONTROLLER_ROOT}/${MatrixRequests.SEARCH_EP}`,
		method: HttpMethodEnum.GET,
		params: dto,
	})

	static get = (code: number): RequestConfigTP<MatrixResponseDTO> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${MatrixRequests.CONTROLLER_ROOT}/${MatrixRequests.GET_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.GET,
	})

	static create = (dto: MatrixSaveRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${MatrixRequests.CONTROLLER_ROOT}/${MatrixRequests.SAVE_EP}`,
		method: HttpMethodEnum.POST,
		params: dto,
	})

	static update = (code: number, dto: MatrixSaveRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${MatrixRequests.CONTROLLER_ROOT}/${MatrixRequests.UPDATE_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.PUT,
		params: dto,
	})

	static delete = (code: number): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${MatrixRequests.CONTROLLER_ROOT}/${MatrixRequests.DELETE_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.DELETE,
	})

	static addLocations = (code: number, dto: MatrixLocationsRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${MatrixRequests.CONTROLLER_ROOT}/${MatrixRequests.ADD_LOCATIONS_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.POST,
		params: dto,
	})

	static removeLocation = (code: number, locationCode: number): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${MatrixRequests.CONTROLLER_ROOT}/${MatrixRequests.REMOVE_LOCATION_EP
			.replace(':code', code.toString())
			.replace(':locationCode', locationCode.toString())}`,
		method: HttpMethodEnum.DELETE,
	})

	static getLocations = (code: number): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${MatrixRequests.CONTROLLER_ROOT}/${MatrixRequests.LOCATIONS_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.GET,
	})

	static availableLocations = (dto: AvailableLocationsRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${MatrixRequests.CONTROLLER_ROOT}/${MatrixRequests.AVAILABLE_LOCATIONS_EP}`,
		method: HttpMethodEnum.GET,
		params: dto,
	})

}
